import { createCrudStore } from "@/store/crudStore";

const materialesStore = createCrudStore("materiales");

export default {
  ...materialesStore,
  actions: {
    ...materialesStore.actions,
    getMateriales: materialesStore.actions.getAllStates,
    postMaterial: materialesStore.actions.create,
    patchMaterial: materialesStore.actions.update,
    deleteMaterial: materialesStore.actions.delete,
  },
};
